import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TrueGrit} from "../TrueGrit";
import {TrueGritGameAssets} from "../TrueGritGameAssets";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TrueGritStatics} from "../TrueGritStatics";
import {TrueGritGameMode} from "../server/TrueGritGameMode";
import {gsap} from "gsap";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";

/**
 * Created by Jerker Nord on 2021-05-03.
 */

export class TrueGritForegroundElements extends PIXI.Container implements StageLayer {

    private _foreground:PIXI.Sprite;
    private _foregroundFS:PIXI.Sprite;
    private _foregroundSuperFS:PIXI.Sprite;
    private _fadeInTimeline:gsap.core.Timeline;
    private _gameLogo:PIXI.Sprite;
    private _gameLogoYPos:number = -44;

    private _fullScreen:PIXI.Graphics;

    constructor() {
        super();
        this.name = "TrueGritForegroundElements";
        this.init();
    }

    private init() {
        this._foreground = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.MAIN_GAME_FOREGROUND)[0]);
        this._foreground.position.set(360, 360);
        this._foreground.anchor.set(0.5, 0.5);
        this.addChild(this._foreground);

        this._foregroundFS = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.FS_FOREGROUND)[0]);
        this._foregroundFS.position.set(360, 360);
        this._foregroundFS.anchor.set(0.5, 0.5);
        this._foregroundFS.alpha = 0;
        this.addChild(this._foregroundFS);

        this._foregroundSuperFS = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.SUPER_FS_FOREGROUND)[0]);
        this._foregroundSuperFS.position.set(360, 360);
        this._foregroundSuperFS.anchor.set(0.5, 0.5);
        this._foregroundSuperFS.alpha = 0;
        this.addChild(this._foregroundSuperFS);

        this._gameLogo = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(NolimitApplication.resourcePath + "/resources/" + "images/introLogo.png")[0]);
        this._gameLogo.position.set(360, -45);
        this._gameLogo.anchor.set(0.5, 0.5);
        this.addChild(this._gameLogo);

        /*
        const bounds:ScreenBounds = NolimitApplication.screenBounds;
        this._fullScreen = new PIXI.Graphics();
        this._fullScreen.clear();
        this._fullScreen.beginFill(0xffffff);
        this._fullScreen.drawRect(bounds.left, bounds.top, bounds.width, bounds.height);
        this._fullScreen.endFill();
        this.addChild(this._fullScreen);

        let test:PIXI.Sprite = new PIXI.Sprite(TrueGrit.assetLoader.getTextures("M1/M1_split_04_transformed")[0]);
        test.position.set(80, 300);
        this.addChild(test);
        let test2:PIXI.Sprite = new PIXI.Sprite(TrueGrit.assetLoader.getTextures("M2/M2_split_04_transformed")[0]);
        test2.position.set(210, 300);
        this.addChild(test2);
        let test3:PIXI.Sprite = new PIXI.Sprite(TrueGrit.assetLoader.getTextures("M3/M3_split_04_transformed")[0]);
        test3.position.set(340, 300);
        this.addChild(test3);
        let test4:PIXI.Sprite = new PIXI.Sprite(TrueGrit.assetLoader.getTextures("M4/M4_split_04_transformed")[0]);
        test4.position.set(480, 300);
        this.addChild(test4);
        let test5:PIXI.Sprite = new PIXI.Sprite(TrueGrit.assetLoader.getTextures("M5/M5_split_04_transformed")[0]);
        test5.position.set(610, 300);
        this.addChild(test5);
         */

        this.onResize();
    }

    onResize():void {
        this.position.y = 0;
        if(!NolimitApplication.isLandscape) {
            this.position.y = this.position.y - (TrueGritStatics.PORTRAIT_Y_OFFSET + NolimitApplication.screenBounds.top) / 2;
            let ratio:number = NolimitApplication.screenBounds.height/NolimitApplication.screenBounds.width;
            if (ratio > 1.50){
                //DO nothing
                this._gameLogo.alpha = 1;
                this._gameLogo.position.y = this._gameLogoYPos;
            }
            if (ratio < 1.50 && ratio > 1.41){
                //Movo logo
                this._gameLogo.alpha = 1;
                this._gameLogo.position.y = this._gameLogoYPos + (500 * (1.50 - ratio));
            }
            if (ratio < 1.41){
                //Disable logo
                this._gameLogo.alpha = 0;
            }
        }
    }

    private swapForegroundTo(newBackground:PIXI.Sprite, fadeInTime:number) {
        this._fadeInTimeline = new gsap.core.Timeline();
        this._fadeInTimeline.add(() => {newBackground.alpha = 0});
        this._fadeInTimeline.add(() => {this.addChild(newBackground)});
        this._fadeInTimeline.add(gsap.to(newBackground, {duration : 1, alpha : 1}));
        this._fadeInTimeline.add(() => {
            for(let i:number = 0; i < this.children.length - 1; i++) {
                this._fadeInTimeline.add(gsap.to(this.children[i], {
                    duration : (fadeInTime / 2),
                    alpha : 0
                }), "-=" + (fadeInTime / 2));
            }
        })
    }

    public setMode(mode:string, fadeInTime:number = 0) {
        if(mode == TrueGritGameMode.FREESPIN || mode == TrueGritGameMode.FREESPIN_AVALANCHE) {
            this.swapForegroundTo(this._foregroundFS, fadeInTime);
        } else if(mode == TrueGritGameMode.FREESPIN_SUPER || (mode == TrueGritGameMode.FREESPIN_SUPER_AVALANCHE)) {
            this.swapForegroundTo(this._foregroundSuperFS, fadeInTime);
        } else {
            this.swapForegroundTo(this._foreground, fadeInTime);
        }
    }
}